<section class="container-heading--xs">
  <h1>Gérez vos documents RH <strong>plus simplement</strong></h1>
  <p>
    Pilotez vos procédures et gérez votre documentation RH à distance, à tout moment, en utilisant un serveur sécurisé, respectant le RGPD,
    et avec l'appui de conseils spécialisés.
  </p>
</section>
